import { Text } from '$tablet-app/src/app/components/Text/Text';
import React from 'react';
import styled from 'styled-components/native';

interface Props {
  text: string;
}

const Title = styled(Text)`
  font-size: 15px;
  margin: 0 0 10px;
`;

const DashboardPanelTitle = (props: Props) => (
  <Title bold preset="grey">
    {props.text}
  </Title>
);

export default DashboardPanelTitle;
